import React from 'react';
import './InvestmentNotFound.css';

function InvestmentNotFound({ email }) {
  return (
    <div className="investment-not-found">
      <div className="not-found-container">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Nie znaleziono inwestycji</h2>
        <p className="not-found-message">
          Przepraszamy, ale inwestycja, którą próbujesz odwiedzić nie została znaleziona.
        </p>
        {email && (
          <div className="not-found-contact">
            <p>Skontaktuj się z nami:</p>
            <a href={`mailto:${email}`} className="contact-email">
              {email}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default InvestmentNotFound;